'use client';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useContext } from 'react';
import { SimpleBlockContext } from './SimpleBlockContext';
import { Tag as AuiTag } from '../Tag';
export const Tag = props => {
  const {
    size
  } = useContext(SimpleBlockContext);
  const tagSize = {
    sm: 'small',
    md: 'small',
    lg: 'regular',
    xl: 'large'
  };
  return /*#__PURE__*/React.createElement(AuiTag, _extends({
    size: tagSize[size]
  }, props));
};